import { Pagination } from 'antd'
import type { PaginationProps } from 'antd'

import { PAGE_SIZE } from '@/libs/constants'

import { ChevronLeftIcon, ChevronRightIcon } from '../Icons'
import styles from './B2BecPagination.module.scss'

type B2becPaginationProps = {
  onPageChange?: (page: number, pageSize: number) => void
  pageSize?: number
  showSizeChanger?: boolean
} & PaginationProps

const B2becPagination = ({
  pageSize = PAGE_SIZE[12],
  showSizeChanger = false,
  onPageChange,
  ...props
}: B2becPaginationProps) => {
  const itemRender = (_: unknown, type, originalElement) => {
    if (type !== 'prev' && type !== 'next') {
      return originalElement
    }

    return (
      <button className={styles.roundButton} type="button">
        {type === 'next' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
      </button>
    )
  }

  return (
    <div className={styles.wrapper}>
      <Pagination
        {...props}
        responsive
        className={styles.wrapper}
        defaultCurrent={1}
        itemRender={itemRender}
        pageSize={pageSize}
        showSizeChanger={showSizeChanger}
        onChange={onPageChange}
      />
    </div>
  )
}

export default B2becPagination
